
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sell/pricing-calculator",
      function () {
        return require("private-next-pages/sell/pricing-calculator/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sell/pricing-calculator"])
      });
    }
  